import React, { Component } from "react";
import { Button, Row, Select, Col, Table } from "antd";
import Card from "../../../components/Card";
import MainLayout from "../../../components/Layout/MainLayout";
import {
  getDataQuan,
  getDataPhuong,
  getDataDuAn,
} from "../../../redux/actions/search.action";
// import "./index.scss";
import { connect } from "react-redux";
import { AxiosGetSecretApi } from "../../../utils/fetchApi";
import ReactHTMLTableToExcel from "react-html-table-to-excel";
import ChartPrint from "../../Statistic/TablePrint";
import "../thong-ke.scss";
import StaticClass from "../../../utils/staticClass";
class ThongKe500 extends Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedQuan: undefined,
      selectedPhuong: undefined,
      selectedDuAn: undefined,
      selectedLoaiDat: undefined,

      tenPhuong: "",
      tenQuan: "",
      tenDuAn: "",

      listQuan: this.props.listQuan,
      listPhuong: this.props.listPhuong,
      listLoaiDat: [],
      listDuAn: [],

      isActiveTab: "QuyHoach",

      dataTableQuyHoach: null,
      dataTableDSD: null,

      dataTableAntDAQH: null,
    };

    this.RomanNumber = [
      "I",
      "II",
      "III",
      "IV",
      "V",
      "VI",
      "VII",
      "VIII",
      "IX",
      "X",
    ];
  }

  async componentDidMount() {
    if (this.props.listQuan.length === 0) this.props.getDataQuan();
    if (this.props.listPhuong.length === 0) this.props.getDataPhuong();
    if (this.props.listDuAn.length === 0) this.props.getDataDuAn();

    this.getDataLoaiDat();
    this.onSearchDAQH();
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevProps.listQuan !== this.props.listQuan) {
      this.setState({ listQuan: this.props.listQuan });
    }

    if (prevProps.listDuAn !== this.props.listDuAn) {
      this.setState({ listDuAn: this.props.listDuAn });
    }

    if (prevProps.listPhuong !== this.props.listPhuong) {
      this.setState({ listPhuong: this.props.listPhuong });
    }

    if (prevState.isActiveTab !== this.state.isActiveTab) {
      this.resetButton();
    }

    if (this.state.isUpdate !== prevState.isUpdate) {
      this.setDataTable(this.dataTableDAQH);
    }
  }

  async getDataLoaiDat() {
    let res = await AxiosGetSecretApi("/api/thongke/doanqh-ssd/tenloaidat");
    if (res && Array.isArray(res)) {
      this.setState({ listLoaiDat: res });
    }
  }

  changeActiveTab(e) {
    this.setState({
      isActiveTab: e,
    });
  }

  async onSearchDat(e) {
    let url = "/api/thongke/doanqh-ssd?";
    if (e !== "TimMoi") {
      let tenDuAn = this.state.listDuAn.filter(
        (o, i) => this.state.selectedDuAn === o.OBJECTID_1
      );
      let tenQuan = this.state.listQuan.filter(
        (o, i) => this.state.selectedQuan === o.MAHUYEN
      );
      let tenPhuong = this.state.listPhuong.filter(
        (o, i) => this.state.selectedPhuong === o.MaPhuong
      );
      this.setState({
        tenDuAn: tenDuAn[0]?.Tendoan,
        tenQuan: tenQuan[0]?.TENHUYEN,
        tenPhuong: tenPhuong[0]?.TenPhuong,
      });

      if (this.state.selectedQuan) {
        url = url + `IDHuyen=${this.state.selectedQuan}&`;
      }
      if (this.state.selectedPhuong) {
        url = url + `IDPhuong=${this.state.selectedPhuong}&`;
      }
      if (this.state.selectedDuAn) {
        url = url + `Madoan=${this.state.selectedDuAn}&`;
      }
      if (this.state.selectedLoaiDat) {
        let name = encodeURIComponent(this.state.selectedLoaiDat);
        url = url + `LoaiDat=${name}&`;
      }
    }

    let res = await AxiosGetSecretApi(url);
    if (res && Array.isArray(res)) {
      let dataTableDSD = res.map((o, i) => {
        return (
          <tr key={i}>
            <td
              style={{
                fontWeight:
                  o.STT === "A" || o.STT === "B" || o.STT === "C" ? 700 : 400,
              }}
            >
              {this.setSTT(o.STT)}
            </td>
            <td
              style={{
                textAlign: "left",
                paddingLeft: "10px",
                fontWeight:
                  o.STT === "A" || o.STT === "B" || o.STT === "C" ? 700 : 400,
              }}
            >
              {this.setLoaiDat(o.STT, o.LoaiDat)}
            </td>
            <td
              style={{
                textAlign: "right",
                paddingRight: "10px",
                fontWeight:
                  o.STT === "A" || o.STT === "B" || o.STT === "C" ? 700 : 400,
              }}
            >
              {StaticClass.formatPrice(o.DienTich)}
            </td>
            <td
              style={{
                textAlign: "right",
                paddingRight: "10px",
                fontWeight:
                  o.STT === "A" || o.STT === "B" || o.STT === "C" ? 700 : 400,
              }}
            >
              {StaticClass.formatPrice(o.TyLe)}
            </td>
          </tr>
        );
      });

      this.setState({
        dataTableDSD: dataTableDSD,
      });
    }
  }

  setLoaiDat = (stt, text) => {
    if (stt.includes(".")) {
      return <div style={{ paddingLeft: "5px" }}>- {text}</div>;
    }
    return text;
  };

  setSTT = (stt, LoaiDat) => {
    let text = "";
    if (stt.includes("A")) {
      if (stt === "A") {
        text = "A";
      } else {
        text = stt.replaceAll("A", "");
        if (text.includes(".")) text = "";
      }
    }

    if (stt.includes("B")) {
      if (stt === "B") {
        text = "B";
      } else {
        text = stt.replaceAll("B", "");
        if (text.includes(".")) text = "";
      }
    }

    if (stt.includes("C")) {
      if (stt === "C") {
        text = "C";
      } else {
        text = stt.replaceAll("C", "");
        if (text.includes(".")) text = "";
      }
    }

    return text;
  };

  async onSearchDAQH(e) {
    for (let i = 0; i < this.props.listQuan.length; i++) {
      this.setState({
        [`${i}_quan`]: false,
      });
    }

    let url = "/api/thongke/doan-qh1-500?";
    if (this.state.selectedQuan) {
      url += `IDHuyen=${this.state.selectedQuan}&`;
    }
    if (this.state.selectedPhuong) {
      url += `IDPhuong=${this.state.selectedPhuong}`;
    }

    if (e === "TimMoi") url = "/api/thongke/doan-qh1-500?";
    let res = await AxiosGetSecretApi(url);

    if (res && Array.isArray(res)) {
      let dataTableQuyHoach = res.map((o, i) => {
        return (
          <tr key={i}>
            <td>{i + 1}</td>
            <td>{o.TenPhuong}</td>
            <td>{o.TENHUYEN}</td>
            <td>{o.TongDuAn}</td>
            <td>{o.CoBanHoanThanh}</td>
            <td>{o.DangTrienKhai}</td>
            <td>{o.ChuaTrienKhai}</td>
            <td>{o.ChamTrienKhai}</td>
          </tr>
        );
      });
      this.setState({
        dataTableQuyHoach: dataTableQuyHoach,
      });
      this.dataTableDAQH = res;
      this.setDataTable(res);
    }
  }

  onChangeQuan(value) {
    let listPhuong = this.props.listPhuong.slice();
    listPhuong = listPhuong.filter((e) => e.MaQuan == value);
    let listDuAn = this.props.listDuAn.filter((e) => e.IDHuyen == value);

    this.setState({
      selectedQuan: value,
      selectedPhuong: undefined,
      listPhuong: listPhuong,
      selectedDuAn: undefined,
      listDuAn,
    });
  }

  onChangePhuong(value, option) {
    let listPhuong = this.props.listPhuong.slice();
    listPhuong = listPhuong.filter((e) => e.MaQuan == option.idquan);

    let selectedQuan = this.state.listQuan.filter(
      (e) => e.MAHUYEN == option.idquan
    );

    let listDuAn = this.props.listDuAn.filter((e) => e.Maphuong == value);

    this.setState({
      selectedQuan:
        selectedQuan && selectedQuan.length !== 0
          ? selectedQuan[0].MAHUYEN
          : undefined,
      selectedPhuong: value,
      selectedDuAn: undefined,
      listPhuong: listPhuong,
      listDuAn: listDuAn,
    });
  }

  onChangeDuAn(value, option) {
    let listPhuong = [];
    let selectedQuan = this.props.listQuan.filter(
      (e) => e.TENHUYEN == option.tenquan
    );
    if (selectedQuan.length !== 0) {
      listPhuong = this.props.listPhuong.filter(
        (e) => e.MaQuan == selectedQuan[0].MAHUYEN
      );
    }
    let selectedPhuong = this.props.listPhuong.filter(
      (e) => e.MaPhuong == option.idphuong
    );

    this.setState({
      selectedQuan:
        selectedQuan && selectedQuan.length !== 0
          ? selectedQuan[0].MAHUYEN
          : undefined,
      selectedPhuong:
        selectedPhuong && selectedPhuong.length !== 0
          ? selectedPhuong[0].MaPhuong
          : undefined,
      listPhuong: listPhuong,
      selectedDuAn: value,
    });
  }

  onChangeLoaiDat(value) {
    this.setState({
      selectedLoaiDat: value,
    });
  }

  resetButton = () => {
    if (this.state.isActiveTab === "QuyHoach") {
      this.onSearchDAQH("TimMoi");
    } else {
      this.onSearchDat("TimMoi");
    }

    for (let i = 0; i < this.props.listQuan.length; i++) {
      this.setState({
        [`${i}_quan`]: false,
      });
    }

    this.setState({
      selectedPhuong: undefined,
      selectedQuan: undefined,
      selectedDuAn: undefined,
      selectedLoaiDat: undefined,

      listQuan: this.props.listQuan,
      listPhuong: this.props.listPhuong,
      listDuAn: this.props.listDuAn,

      tenDuAn: "",
      tenQuan: "",
      tenPhuong: "",
    });
  };

  setDataTable(data) {
    let listQuan = this.props.listQuan.map((e) => {
      return e.TENHUYEN;
    });

    let convertData = [];
    listQuan.forEach((e) => {
      let chil = [];
      data.forEach((o) => {
        if (o.TENHUYEN === e) {
          chil.push(o);
        }
      });
      convertData.push(chil);
    });
    let newData = [];
    convertData = convertData.filter((e) => e.length > 0);

    convertData.forEach((e, i) => {
      let dataQuan = {
        ChamTrienKhai: 0,
        ChuaTrienKhai: 0,
        CoBanHoanThanh: 0,
        DangTrienKhai: 0,
        TENHUYEN: e[0].TENHUYEN,
        TenPhuong: (
          <div style={{ display: "flex" }}>
            <div
              class={this.state[`${i}_quan`] ? "arrow-up" : "arrow-down"}
              onClick={() => {
                this.setState({
                  isUpdate: !this.state.isUpdate,
                  [`${i}_quan`]: !this.state[`${i}_quan`],
                });
              }}
            ></div>

            <div>{e[0].TENHUYEN}</div>
          </div>
        ),
        TongDuAn: 0,
        children: convertData[i],
      };
      e.forEach((o) => {
        dataQuan.ChamTrienKhai += o.ChamTrienKhai;
        dataQuan.ChuaTrienKhai += o.ChuaTrienKhai;
        dataQuan.CoBanHoanThanh += o.CoBanHoanThanh;
        dataQuan.DangTrienKhai += o.DangTrienKhai;
        dataQuan.TongDuAn += o.TongDuAn;
      });
      newData.push(dataQuan);
    });

    let dataTableAntDAQH = newData.map((e, i) => {
      return (
        <>
          {e.children.length > 1 && (
            <tr key={i}>
              <td style={{ fontWeight: "bold" }}>{this.RomanNumber[i]}</td>
              {/* <td>{e.TENHUYEN}</td> */}
              <td>{newData.length === 1 ? e.TENHUYEN : e.TenPhuong}</td>
              <td>{e.TongDuAn}</td>
              <td>{e.CoBanHoanThanh}</td>
              <td>{e.DangTrienKhai}</td>
              <td>{e.ChuaTrienKhai}</td>
              <td>{e.ChamTrienKhai}</td>
            </tr>
          )}

          {e.children.map((o, index) => {
            return (
              <tr
                key={index}
                style={{
                  display:
                    newData.length === 1
                      ? " "
                      : this.state[`${i}_quan`] || e.children.length === 1
                        ? " "
                        : "none",
                }}
              >
                <td>{index + 1}</td>
                {/* <td>{o.TENHUYEN}</td> */}
                <td>{o.TenPhuong}</td>
                <td>{o.TongDuAn}</td>
                <td>{o.CoBanHoanThanh}</td>
                <td>{o.DangTrienKhai}</td>
                <td>{o.ChuaTrienKhai}</td>
                <td>{o.ChamTrienKhai}</td>
              </tr>
            );
          })}
        </>
      );
    });

    this.setState({
      dataTableAntDAQH: dataTableAntDAQH,
    });
  }

  render() {
    return (
      <MainLayout
        title={"Thống kê chi tiết dự án quy hoạch chi tiết 1/500"}
        {...this.props}
      >
        <div className="page-with-card">
          <Card title="Thống kê chi tiết dự án quy hoạch chi tiết 1/500">
            <div className="thong-ke thong-ke-500">
              {/* tab */}
              <div className="fl-center mt-20 mb-20">
                <Button
                  type={this.state.isActiveTab === "QuyHoach" ? "primary" : ""}
                  className="button-tab"
                  style={{
                    color:
                      this.state.isActiveTab === "QuyHoach" ? "" : "#787878",
                  }}
                  onClick={() => this.changeActiveTab("QuyHoach")}
                >
                  Dự án quy hoạch
                </Button>

                <Button
                  type={this.state.isActiveTab === "Dat" ? "primary" : ""}
                  className="button-tab"
                  style={{
                    color: this.state.isActiveTab === "Dat" ? "" : "#787878",
                  }}
                  onClick={() => this.changeActiveTab("Dat")}
                >
                  Đất sử dụng
                </Button>
              </div>

              {/* search input */}
              {this.state.isActiveTab === "QuyHoach" ? (
                <Row gutter={[20, 0]}>
                  <Col span={6} className="group">
                    <div className="gr-title">
                      <div className="text">Quận/Huyện:</div>
                    </div>

                    <div className="gr-body">
                      <Select
                        className="select"
                        showSearch
                        value={this.state.selectedQuan}
                        onChange={(value) => this.onChangeQuan(value)}
                        optionFilterProp = "name"
                      >
                        {this.state.listQuan.map((e, i) => (
                          <Select.Option value={e.MAHUYEN} key={i} name = {e.TENHUYEN}>
                            {e.TENHUYEN}
                          </Select.Option>
                        ))}
                      </Select>
                    </div>
                  </Col>

                  <Col span={6} className="group">
                    <div className="gr-title">
                      <div className="text">Phường/Xã:</div>
                    </div>

                    <div className="gr-body">
                      <Select
                        className="select"
                        showSearch
                        onChange={(value, option) =>
                          this.onChangePhuong(value, option)
                        }
                        value={this.state.selectedPhuong}
                        optionFilterProp = "name"
                      >
                        {this.state.listPhuong.map((e, i) => (
                          <Select.Option
                            value={e.MaPhuong}
                            idquan={e.MaQuan}
                            key={i}
                            name = {e.TenPhuong}
                          >
                            {e.TenPhuong}
                          </Select.Option>
                        ))}
                      </Select>
                    </div>
                  </Col>
                </Row>
              ) : (
                <Row gutter={[20, 0]}>
                  <Col span={6} className="group">
                    <div className="gr-title">
                      <div className="text">Quận/Huyện:</div>
                    </div>

                    <div className="gr-body">
                      <Select
                        className="select"
                        showSearch
                        value={this.state.selectedQuan}
                        onChange={(value) => this.onChangeQuan(value)}
                        optionFilterProp = "name"
                      >
                        {this.state.listQuan.map((e, i) => (
                          <Select.Option value={e.MAHUYEN} key={i} name = {e.TENHUYEN}>
                            {e.TENHUYEN}
                          </Select.Option>
                        ))}
                      </Select>
                    </div>
                  </Col>

                  <Col span={6} className="group">
                    <div className="gr-title">
                      <div className="text">Phường/Xã:</div>
                    </div>

                    <div className="gr-body">
                      <Select
                        className="select"
                        showSearch
                        onChange={(value, option) =>
                          this.onChangePhuong(value, option)
                        }
                        value={this.state.selectedPhuong}
                        optionFilterProp = "name"
                      >
                        {this.state.listPhuong.map((e, i) => (
                          <Select.Option
                            value={e.MaPhuong}
                            idquan={e.MaQuan}
                            key={i}
                            name = {e.TenPhuong}
                          >
                            {e.TenPhuong}
                          </Select.Option>
                        ))}
                      </Select>
                    </div>
                  </Col>

                  <Col span={6} className="group">
                    <div className="gr-title">
                      <div className="text">Dự Án:</div>
                    </div>

                    <div className="gr-body">
                      <Select
                        className="select"
                        showSearch
                        value={this.state.selectedDuAn}
                        onChange={(value, option) =>
                          this.onChangeDuAn(value, option)
                        }
                        optionFilterProp = "name"
                      >
                        {this.state.listDuAn.map((e, i) => (
                          <Select.Option
                            value={e.OBJECTID_1}
                            key={i}
                            idphuong={e.Maphuong}
                            tenquan={e.TENHUYEN}
                            name = {e.Tendoan}
                          >
                            {e.Tendoan}
                          </Select.Option>
                        ))}
                      </Select>
                    </div>
                  </Col>

                  <Col span={6} className="group">
                    <div className="gr-title">
                      <div className="text">Loại đất:</div>
                    </div>

                    <div className="gr-body">
                      <Select
                        className="select"
                        showSearch
                        onChange={(value) => this.onChangeLoaiDat(value)}
                        value={this.state.selectedLoaiDat}
                      >
                        {this.state.listLoaiDat.map((e, i) => (
                          <Select.Option value={e.TenLoaiDat} key={i}>
                            {e.TenLoaiDat}
                          </Select.Option>
                        ))}
                      </Select>
                    </div>
                  </Col>
                </Row>
              )}

              {/* button search */}
              <div
                style={{
                  display: "flex",
                  marginTop: "15px",
                  marginBottom: "10px",
                }}
              >
                <Button
                  type="primary"
                  className="button"
                  style={{ width: "117px", fontWeight: 700, height: "40px" }}
                  onClick={this.resetButton}
                >
                  Tìm mới
                </Button>

                <Button
                  type="primary"
                  className="button"
                  style={{
                    width: "117px",
                    marginLeft: "10px",
                    fontWeight: 700,
                    height: "40px",
                  }}
                  onClick={() => {
                    if (this.state.isActiveTab === "QuyHoach") {
                      this.onSearchDAQH();
                    } else {
                      this.onSearchDat();
                    }
                  }}
                >
                  Tìm kiếm
                </Button>
              </div>

              {this.state.isActiveTab === "QuyHoach" ? (
                <>
                  <table
                    id="chart-table"
                    style={{ width: "100%", display: "none" }}
                  >
                    <tbody>
                      <tr>
                        <th rowSpan="2">STT</th>
                        <th rowSpan="2">Phường/Xã</th>
                        <th rowSpan="2">Quận/Huyện</th>
                        <th rowSpan="2">Tổng dự án</th>
                        <th colSpan="4">Tốc độ triển khai</th>
                      </tr>
                      <tr>
                        <th>Cơ bản hoàn thành</th>
                        <th>Đang triển khai</th>
                        <th>Chưa triển khai</th>
                        <th>Chậm triển khai</th>
                      </tr>
                      {this.state.dataTableQuyHoach}
                    </tbody>
                  </table>

                  <table id="chart-table" style={{ width: "100%" }}>
                    <tbody>
                      <tr>
                        <th rowSpan="2" style={{ width: "50px" }}>
                          STT
                        </th>
                        <th rowSpan="2" style={{ width: "160px" }}>
                          Quận/Huyện
                        </th>
                        {/* <th rowSpan="2" style={{ width: "180px" }}>
                          Phường/Xã
                        </th> */}
                        <th rowSpan="2">Tổng dự án</th>
                        <th colSpan="4">Tốc độ triển khai</th>
                      </tr>
                      <tr>
                        <th>Cơ bản hoàn thành</th>
                        <th>Đang triển khai</th>
                        <th>Chưa triển khai</th>
                        <th>Chậm triển khai</th>
                      </tr>

                      {this.state.dataTableAntDAQH}
                    </tbody>
                  </table>
                </>
              ) : (
                <div>
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-around",
                      marginBottom: "15px",
                      marginTop: "20px",
                    }}
                  >
                    <span>
                      Bảng thống kê chi tiết sử dụng đất dự án:{" "}
                      {this.state.tenDuAn}
                    </span>
                    <span>Phường/Xã: {this.state.tenPhuong}</span>
                    <span>Quận/Huyện: {this.state.tenQuan} </span>
                  </div>

                  <table
                    id="chart-table"
                    className="tableDST"
                    style={{ width: "100%" }}
                  >
                    <tbody>
                      <tr>
                        <th>STT</th>
                        <th>Loại đất</th>
                        <th>Diện tích (m²)</th>
                        <th>Tỷ lệ (%)</th>
                      </tr>
                      {this.state.dataTableDSD}
                    </tbody>
                  </table>
                </div>
              )}

              <div
                style={{
                  display: "flex",
                  marginTop: "15px",
                  marginBottom: "10px",
                  justifyContent: "center",
                }}
              >
                <ReactHTMLTableToExcel
                  id="test-table-xls-button"
                  className="ant-btn ant-btn-primary-cus"
                  table="chart-table"
                  filename={"ThongKeQuyHoachChiTiet"}
                  sheet="tablexls"
                  buttonText="Tải Excel"
                />
                <Button
                  type="primary"
                  className="button"
                  style={{
                    width: "117px",
                    marginLeft: "10px",
                    fontWeight: 700,
                    height: "40px",
                  }}
                  onClick={() =>
                    this.state.isActiveTab === "QuyHoach"
                      ? ChartPrint("Thống kê dự án quy hoạch chi tiết 1/500")
                      : ChartPrint(
                          `Bảng thống kê chi tiết sử dụng đất dự án: ${
                            this.state.tenDuAn ? this.state.tenDuAn : ""
                          } Phường/Xã: ${
                            this.state.tenPhuong ? this.state.tenPhuong : ""
                          } Quận/Huyện: ${
                            this.state.tenQuan ? this.state.tenQuan : ""
                          }`
                        )
                  }
                >
                  In
                </Button>
              </div>
            </div>
          </Card>
        </div>
      </MainLayout>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    listQuan: state.search.listQuan,
    listPhuong: state.search.listPhuong,
    listDuAn: state.search.listDuAn,
  };
};

const mapDispatchToProps = {
  getDataQuan: getDataQuan,
  getDataPhuong: getDataPhuong,
  getDataDuAn: getDataDuAn,
};

export default connect(mapStateToProps, mapDispatchToProps)(ThongKe500);
